import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Form,
  Input,
  TextArea,
  Button,
  Message,
  Icon,
} from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import "../css/home.css";
import "../css/index.css";
import Typography from "@mui/material/Typography";

const validEmailRegex =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

const SubmitFeature = ({ contactURL, header }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    requestDetails: "",
  });
  const [errors, setErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrors([]);

    const newErrors = [];
    if (formData.name.length < 5) {
      newErrors.push("Name must be 5 characters long!");
    }
    if (!validEmailRegex.test(formData.email)) {
      newErrors.push("Email is not valid!");
    }
    if (formData.requestDetails.length < 25) {
      newErrors.push("Request Details must be minimum 25 characters long!");
    }

    setErrors(newErrors);

    if (newErrors.length === 0) {
      try {
        const response = await axios.post(contactURL, formData);
        if (response.status === 200) {
          setSuccessMessage("Your request has been submitted! Thank you.");
          setFormData({ name: "", email: "", requestDetails: "" }); // Clear form
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setErrors(["Failed to submit request. Please try again."]); // Generic error
      }
    } else {
      console.error("Invalid Form");
    }
  };

  return (
    <Container style={{ marginTop: "2em", padding: "1em" }}>
      <Typography
        variant="h5"
        gutterBottom
        align="center"
        sx={{
          color: "primary.dark",
          fontWeight: 600,
          mb: 2,
          mt: 0.5,
          fontSize: { xs: "1.5rem", md: "1.75rem" },
          letterSpacing: "-0.02em",
        }}
      >
        <Icon name="lightbulb outline" /> Submit a Feature Request
      </Typography>

      {errors.length > 0 && (
        <Message
          error
          header="Please correct the following errors:"
          list={errors}
        />
      )}

      {successMessage && (
        <Message positive>
          <Message.Header>{successMessage}</Message.Header>
        </Message>
      )}

      <Form onSubmit={handleSubmit} style={{ marginTop: "1.5em" }}>
        <Form.Field required>
          <label>Name</label>
          <Input
            placeholder="Your Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </Form.Field>

        <Form.Field required>
          <label>Email</label>
          <Input
            placeholder="Your Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </Form.Field>

        <Form.Field required>
          <label>Request Details</label>
          <TextArea
            placeholder="Describe the feature you'd like to request"
            name="requestDetails"
            value={formData.requestDetails}
            onChange={handleChange}
          />
        </Form.Field>

        <Button type="submit" primary>
          <Icon name="send" /> Submit Request
        </Button>
      </Form>
    </Container>
  );
};

export default SubmitFeature;
